import { tns } from 'tiny-slider/src/tiny-slider';
import 'tiny-slider/src/tiny-slider.scss';
import Swiper from 'swiper';



export function sliderInit() {

  const section_homesite_banner = document.querySelector('.section_homesite_banner');
  if (typeof (section_homesite_banner) != undefined && typeof (section_homesite_banner) != null && section_homesite_banner != null && typeof (section_homesite_banner) != 'undefined') {
    console.log(section_homesite_banner);
    // slider on homesite banner
    const sliderHomesiteBanner = () => tns({
      container: '.section_homesite_banner__sliderBox',
      items: 1,
      autoplay: true,
      speed: 1000,
      autoplayTimeout: 5000,
      autoplayButtonOutput: false,
      swipeAngle: false,
      navContainer: '.section_homesite_banner__sliderNav > .dots',
    });
    sliderHomesiteBanner();
    
  }

  const section_homesite_collection_slider = document.querySelector('.section_homesite_collection_slider');
  if (typeof (section_homesite_collection_slider) != undefined && typeof (section_homesite_collection_slider) != null && section_homesite_collection_slider != null && typeof (section_homesite_collection_slider) != 'undefined') {
    console.log(section_homesite_collection_slider);
    // slider on homesite banner
    const sliderHomesiteBanner = () => tns({
      container: '.section_homesite_collection_slider__sliderBox',
      items: 1,
      // autoplay: true,
      speed: 1000,
      autoplayTimeout: 15000,
      autoplayButtonOutput: false,
      swipeAngle: false,
      navContainer: '.section_homesite_collection_slider__sliderNav > .dots',
      prevButton: '.section_homesite_collection_slider__sliderNavArrowPrev .buttonPrev',
      nextButton: '.section_homesite_collection_slider__sliderNavArrowNext > .buttonNext',
    });
    sliderHomesiteBanner();
    
  }

  const section_woocommerce_lookbook = document.querySelector('.section_woocommerce_lookbook');
  if (typeof (section_woocommerce_lookbook) != undefined && typeof (section_woocommerce_lookbook) != null && section_woocommerce_lookbook != null && typeof (section_woocommerce_lookbook) != 'undefined') {
    console.log(section_woocommerce_lookbook);
    // slider on homesite banner
    const sliderHomesiteBanner = () => tns({
      container: '.section_woocommerce_lookbook__sliderBox',
      items: 1,
      slideBy: 1,
      center: true,
      gutter: 10,
      edgePadding: 20,
      mouseDrag: true,
      // autoplay: true,
      speed: 1000,
      autoplayTimeout: 5000,
      autoplayButtonOutput: false,
      swipeAngle: false,
      navContainer: '.section_woocommerce_lookbook__sliderNav > .dots',
      responsive: {
        950: {
          gutter: 100,
          edgePadding: 300,
          mouseDrag: true,

        }
      },
    });
    sliderHomesiteBanner();
    
  }

  const commentlist = document.querySelector('.commentlist');
  if (typeof (commentlist) != undefined && typeof (commentlist) != null && commentlist != null && typeof (commentlist) != 'undefined') {
    console.log(commentlist);
    // slider on homesite banner
    const sliderCommentlist = () => tns({
      container: '.commentlist',
      items: 1,
      slideBy: 1,
      loop: false,
      // center: true,
      gutter: 10,
      edgePadding: 20,
      mouseDrag: true,
      // autoplay: true,
      speed: 1000,
      autoplayTimeout: 5000,
      autoplayButtonOutput: false,
      swipeAngle: false,
      // navContainer: '.commentlist__sliderNav > .dots',
      responsive: {
        950: {
          items: 2,
          gutter: 20,
          edgePadding: 70,
          mouseDrag: true,

        }
      },
    });
    sliderCommentlist();
    
  }

  //featured product slider on homesite
  const section_homesite_featured_products = document.querySelector('.section_homesite_featured_products');
  if (typeof (section_homesite_featured_products) != undefined && typeof (section_homesite_featured_products) != null && section_homesite_featured_products != null && typeof (section_homesite_featured_products) != 'undefined') {
    console.log(section_homesite_featured_products);
    // slider on homesite banner
    const slidersection_homesite_featured_products = () => tns({
      container: '.section_homesite_featured_products__sliderBox', 
      items: 1,
      slideBy: 'page',
      loop: true,
      // center: true,
      gutter: 0,
      edgePadding: 0,
      mouseDrag: true,
      autoplay: true,
      speed: 1000,
      autoplayTimeout: 5000,
      autoplayButtonOutput: false,
      swipeAngle: false,
      nav: true,
      navPosition: 'bottom',
      // navAsThumbnails: true,
      // navContainer: '.section_homesite_featured_products__sliderNav > .dots',
      responsive: {
        550: {
          items: 2,
          slideBy: 'page',
          gutter: 0,
          edgePadding: 0,
          mouseDrag: true,

        },
        830: {
          items: 3,
          slideBy: 'page',
          gutter: 0,
          edgePadding: 0,
          mouseDrag: true,

        },
        1200: {
          items: 4,
          slideBy: 'page',
          gutter: 0,
          edgePadding: 0,
          mouseDrag: true,
          // navContainer: '.section_homesite_featured_products__sliderNav > .dots',

      // center: true,

        }
      },
    });
    slidersection_homesite_featured_products();
    
  }

  
}